import Vue from 'vue';

if (!window.EventBusInstance) {
  window.EventBusInstance = new Vue();
}

export default window.EventBusInstance;
